import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';

import Checkbox from 'ati-ui-react/components/Checkbox';
import setUrlParam from 'utils/setUrlParam';

const WithDriver = observer(() => {
  const {
    findTrucksStore: {
      fields: { with_driver },
      updateCheckBox,
    },
  } = useStores();

  return (
    <Checkbox
      label="Аренда с водителем"
      onChange={() => {
        updateCheckBox({ field: 'with_driver', value: !with_driver });
        setUrlParam({ field: 'with_driver', value: !with_driver });
      }}
      checked={with_driver}
      size="small"
    />
  );
});

export default WithDriver;
